import _ from 'lodash'
import {createProjectModel} from 'company-management/utils/project-model'
import constants from 'common/constants'
import {getAllRobotList, getFailedList, getFailedStat, exportFailed, companies} from './service'

const {dateFormat} = constants

const model = createProjectModel({
    projectNamespace: 'groupMsgFailedList',

    state: {
        tableList: {},
        failedStat: null,
    },

    effects: {
        // 所有机器人列表
        *getAllRobotList({payload}, {call}) {
            return yield call(getAllRobotList, payload)
        },

        // 获取记录列表
        *getTableList(xx, {call, put, select, all}) {
            const {tableList} = yield select((allState) => allState[model.namespace])

            const newParams = {
                offset: tableList.pagination.pageSize * (tableList.pagination.current - 1),
                limit: tableList.pagination.pageSize,
                ...tableList.params,
                statuses: tableList.params?.statuses.join(',') || undefined,
            }

            if (newParams.execute_time?.length) {
                newParams.execute_time_from =
                    `${newParams.execute_time[0].format(dateFormat)} 00:00:00` || undefined
                newParams.execute_time_to =
                    `${newParams.execute_time[1].format(dateFormat)} 23:59:59` || undefined
                delete newParams.execute_time
            }

            const [listRes, statRes] = yield all([
                call(getFailedList, {params: newParams}),
                yield call(getFailedStat, {params: newParams}),
            ])

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableList.dataSource = listRes.data
                    draft.tableList.pagination.total = _.get(listRes, 'pagination.rows_found', 0)
                    draft.failedStat = statRes.data
                },
            })
        },

        // 导出数据
        *exportFailed(xx, {call, select}) {
            const {tableList} = yield select((allState) => allState[model.namespace])

            const newParams = {
                ...tableList.params,
                statuses: tableList.params?.statuses.join(',') || undefined,
            }

            if (newParams.execute_time?.length) {
                newParams.execute_time_from =
                    `${newParams.execute_time[0].format(dateFormat)} 00:00:00` || undefined
                newParams.execute_time_to =
                    `${newParams.execute_time[1].format(dateFormat)} 23:59:59` || undefined
                delete newParams.execute_time
            }

            return yield call(exportFailed, {params: newParams})
        },

        // 商家列表
        *companies(xx, {call}) {
            return yield call(companies, {offset: 0, limit: 10000})
        },
    },
})

export default model
